 
 
 
 
 
 
/**
 * GeopolView class.
 *
 * @class GeopolView
 * @module Models
 */
define(['./geopolViewsMapping'], function(geopolViewsMapping) {
    'use strict';

    /**
     * @ignore
     * @param {String} geopolCode
     */
    function GeopolView(geopolCode) {
        if (!geopolViewsMapping.hasOwnProperty(geopolCode)) {
            geopolCode = 'Unified';
            console.warn('Incorrect geopolitical view code passed to GeopolViewService.',
                'Defaulting to "' + geopolCode + '".');
        }
        this.code = geopolCode;
    }

    /**
     * Returns the code of the geopolitical view.
     * @method getCode
     * @return {String}
     */
    GeopolView.prototype.getCode = function() {
        return this.code;
    };

    /**
     * Returns the label of the geopolitical view.
     * @method getLabel
     * @return {String}
     */
    GeopolView.prototype.getLabel = function() {
        return geopolViewsMapping[this.code].label;
    };

    Object.defineProperty(GeopolView.prototype, 'toString', {
        enumerable: false,
        value: function() {
            return this.getCode();
        }
    });

    return GeopolView;
});



// WEBPACK FOOTER //
// ./config/geopolView/geopolView.js